export const CONSOLE_API_URL = 'console-api-service/api/v1'
export const SERVER = ''
